import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { AddMiniIcon, CalendarDateIcon } from '@calendly/ui/components/icons';
import { BodyText } from '@calendly/ui/components/typography';
import { colorIconSecondary } from '@calendly/ui/theme';
import classNames from 'classnames';
import { forwardRef } from 'react';
const containerWithActionsCss = "cdev9zm";
const containerCss = "chc20pq";
const Container = forwardRef((props, ref) => {
  const {
    withActions,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, {
    [containerWithActionsCss]: withActions
  }, props.className)} />;
});
const headerWithIconCss = "htg1prl";
const HeaderWithIcon = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(headerWithIconCss, props.className)} />;
});
export const DateSpecificHeader = ({
  handleAdd,
  compact = false,
  readOnly
}) => <Container withActions>
    <Container>
      <HeaderWithIcon>
        <CalendarDateIcon color={colorIconSecondary} />
        <BodyText size={compact ? 'medium' : 'large'} weight={compact ? 'normal' : 'bold'}>
          {I18n.t('publisher.event_type_editor.sections.available_hours.date_overrides.date_specific_hours')}
        </BodyText>
      </HeaderWithIcon>
      {!readOnly && <BodyText size={compact ? 'small' : 'medium'} color="muted">
        {I18n.t('publisher.event_type_editor.sections.availability.date_specific_hours.subtitle')}
      </BodyText>}
    </Container>
    {handleAdd && <Button aria-label={I18n.t('publisher.event_type_editor.sections.availability.date_overrides.add_hours')} decoration="secondary-outline" onClick={handleAdd} responsive={false} size="small">
        <AddMiniIcon />
        {I18n.t('publisher.event_type_editor.sections.availability.hours.title')}
      </Button>}
  </Container>;

require("./date_specific_header.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./date_specific_header.js");